import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";

export default function CTABanner({ onBookingOpen }) {
  const { t } = useLanguage();
  const section = t("ctaBanner");

  return (
    <section data-testid="cta-banner" className="py-24 md:py-32 bg-[#1a1a2e]">
      <Reveal className="max-w-4xl mx-auto px-6 md:px-12 lg:px-16 text-center">
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-[1.1] tracking-[-0.02em] mb-6">
          {section.headline}
        </h2>
        <p className="text-white/60 text-base max-w-2xl mx-auto mb-10 leading-relaxed">{section.description}</p>
        <Button
          data-testid="cta-banner-btn"
          onClick={onBookingOpen}
          className="bg-[#1a5c4a] text-white hover:bg-[#154a3c] rounded-full px-10 py-6 text-sm font-semibold transition-all duration-300 hover:shadow-xl hover:-translate-y-0.5"
        >
          {section.cta} <ArrowRight className="h-4 w-4 ml-2" />
        </Button>
      </Reveal>
    </section>
  );
}
